export const PASSWORD_MIN_LENGTH = 15;
export const PASSWORD_MAX_LENGTH = 128;

export const PASSWORD_ERROR_CODES = Object.freeze({
    TOO_SHORT: 'password_too_short',
    TOO_LONG: 'password_too_long',
    MATCHES_USERNAME: 'password_matches_username',
    MATCHES_EMAIL: 'password_matches_email',
    IS_COMMON: 'password_is_common',
});

const COMMON_PASSWORDS = new Set([
    '123456789012345',
    'passwordpassword',
    'qwertyqwertyqwerty',
    'quickverleih2026',
]);

export const isPasswordValidationError = (errorCode) => (
    Object.values(PASSWORD_ERROR_CODES).includes(errorCode)
);

export const getPasswordValidationError = (password, username = '', email = '') => {
    const passwordValue = password ?? '';
    const passwordLength = Array.from(passwordValue).length;

    if (passwordLength < PASSWORD_MIN_LENGTH) {
        return PASSWORD_ERROR_CODES.TOO_SHORT;
    }

    if (passwordLength > PASSWORD_MAX_LENGTH) {
        return PASSWORD_ERROR_CODES.TOO_LONG;
    }

    const normalizedPassword = passwordValue.toLowerCase();
    if (username && normalizedPassword === username.toLowerCase()) {
        return PASSWORD_ERROR_CODES.MATCHES_USERNAME;
    }

    if (email && normalizedPassword === email.toLowerCase()) {
        return PASSWORD_ERROR_CODES.MATCHES_EMAIL;
    }

    if (COMMON_PASSWORDS.has(normalizedPassword)) {
        return PASSWORD_ERROR_CODES.IS_COMMON;
    }

    return null;
};

